export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('form_label_platformNo') || '渠道编号',
    field: 'platformNo',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_platformName') || '渠道名称',
    field: 'platformName',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_regionName') || '所属地区名称',
    field: 'regionName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_ecomCompanyName') || '申请公司',
    field: 'ecomCompanyName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_custName') || '客户名称',
    field: 'custName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_platformType') || '渠道类型',
    field: 'v_platformType',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_warehousePmaCode') || '仓库平台账户',
    field: 'warehousePmaName',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_ecomPmaCode') || '电商平台账户',
    field: 'ecomPmaName',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_shippingMethod') || '发运方式',
    field: 'shippingMethod',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_warehouseCode') || '仓库代码',
    field: 'warehouseCode',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_shipNode') || '分销商ID',
    field: 'shipNode',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('form_label_remark') || '备注说明',
    field: 'remark',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '有效状态',
    field: 'platformStatus',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
